import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { PrivacyPage } from '../../api/api-types';
import type { Loadable } from '../../guards/ngrx-loader.guard';
import { actions } from './privacy.actions';

interface PrivacyState {
    content: Loadable<PrivacyPage>;
}

const initialState: PrivacyState = {
    content: null,
};

export const state = createFeature({
    name: 'privacy',
    reducer: createReducer(
        initialState,
        on(
            actions.loadDealerPrivacySuccess,
            (state, { privacy }): PrivacyState => ({
                ...state,
                content: privacy,
            }),
        ),
        on(
            actions.loadDealerPrivacyFailure,
            (state): PrivacyState => ({
                ...state,
                content: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingContent = createSelector(baseSelectors.selectContent, (content) => content === null);
        const selectLoadedContent = createSelector(baseSelectors.selectContent, (content) => content as PrivacyPage);

        return {
            selectIsLoadingContent,
            selectLoadedContent,
        };
    },
});
